import styled from "styled-components";

import DefaultAppBar from "@material-ui/core/AppBar";
import DefaultToolbar from "@material-ui/core/Toolbar";

import { HEADER_HEIGHT } from "constants/layout";

export const AppBar = styled(DefaultAppBar)`
  && {
    position: fixed;
    top: 0;
    left: 0;

    width: 100%;
    height: ${HEADER_HEIGHT};
  }
`;

export const Toolbar = styled(DefaultToolbar)`
  && {
    justify-content: space-between;
    align-items: center;
    height: 100%;

    padding: 23px 32px;
  }
`;

export const TitleContainer = styled.div`
  display: flex;
  align-items: center;
`;

export const LogoContainer = styled.div`
  display: flex;

  margin-right: 12px;
`;
